import { api } from "../../../config/api";

// Categories API
export const getAllCategoriesApi = async (token) => {
  return await api.get("/api/inventory-categories", { headers: { Authorization: `Bearer ${token}` } });
};

export const createCategoryApi = async (token, data) => {
  return await api.post("/api/inventory-categories", data, { headers: { Authorization: `Bearer ${token}` } });
};

export const updateCategoryApi = async (token, id, data) => {
  return await api.put(`/api/inventory-categories/${id}`, data, { headers: { Authorization: `Bearer ${token}` } });
};

export const deleteCategoryApi = async (token, id) => {
  return await api.delete(`/api/inventory-categories/${id}`, { headers: { Authorization: `Bearer ${token}` } });
};

// Inventory API
export const getAllInventoryApi = async (token) => {
  return await api.get("/api/inventory", { headers: { Authorization: `Bearer ${token}` } });
};

export const createInventoryApi = async (token, data) => {
  return await api.post("/api/inventory", data, { headers: { Authorization: `Bearer ${token}` } });
};

export const updateInventoryApi = async (token, id, data) => {
  return await api.put(`/api/inventory/${id}`, data, { headers: { Authorization: `Bearer ${token}` } });
};

export const deleteInventoryApi = async (token, id) => {
  return await api.delete(`/api/inventory/${id}`, { headers: { Authorization: `Bearer ${token}` } });
};

// Purchases API
export const getAllInvoicesApi = async (token) => {
  return await api.get("/api/purchases", { headers: { Authorization: `Bearer ${token}` } });
};

export const getAllPurchasesApi = async (token) => {
  return await api.get("/api/purchases/items", { headers: { Authorization: `Bearer ${token}` } });
};

export const getInvoiceByIdApi = async (token, id) => {
  return await api.get(`/api/purchases/${id}`, { headers: { Authorization: `Bearer ${token}` } });
};

export const createPurchaseInvoiceApi = async (token, data) => {
  return await api.post("/api/purchases", data, { headers: { Authorization: `Bearer ${token}` } });
};

export const cancelPurchaseInvoiceApi = async (token, id) => {
  return await api.put(`/api/purchases/${id}/cancel`, {}, { headers: { Authorization: `Bearer ${token}` } });
};

export const adjustInventoryApi = async (token, id, data) => {
  return await api.post(`/api/inventory/${id}/adjust`, data, { headers: { Authorization: `Bearer ${token}` } });
};

export const getInventoryLotsApi = async (token, id) => {
  return await api.get(`/api/inventory/${id}/lots`, { headers: { Authorization: `Bearer ${token}` } });
};
